export const CO_CREATED_CONTENT = "Sponsor Content";
export const ADVERTORIAL = "Advertorial from";
export const SPONSOR_LABEL = "Paid Content";
export const TRANSPARENCY_LINK =
    "https://solutionsmedia.cbcrc.ca/en/page/paid-content-at-cbc";
export const TITLE_VERBIAGE =
    "This content was paid for by an advertiser. This is not CBC journalistic content. Click here to learn more about our branded content guidelines.";
